import { RefObject, useEffect } from "react"

export const useSnapToFirstNonStickyOnResize = (wrapperRef: RefObject<HTMLDivElement>, thSelector: string = ".ant-table-thead th") => {
    useEffect(() => {
        const snap = () => {
            if (!wrapperRef.current) {
                return
            }

            // Find the scrollable container - try multiple selectors
            const container = wrapperRef.current.querySelector<HTMLDivElement>(".ant-table-content")

            if (!container) {
                return
            }

            const tableHeaders = Array.from(wrapperRef.current.querySelectorAll<HTMLElement>(thSelector))
            if (!tableHeaders.length) {
                return
            }
            // Find the first non-sticky th
            const firstNonStickyTableHeader = tableHeaders.find((th) => !th.classList.contains("ant-table-cell-fix-left") && !th.classList.contains("ant-table-cell-fix-right"))
            if (!firstNonStickyTableHeader) {
                return
            }

            container.scrollTo({ left: 0, behavior: "smooth" })
        }
        window.addEventListener("resize", snap)
        // Snap after a short delay on mount (to ensure Table is rendered)
        const initialSnapCallTimeout = setTimeout(snap, 200)
        return () => {
            window.removeEventListener("resize", snap)
            clearTimeout(initialSnapCallTimeout)
        }
    }, [wrapperRef, thSelector])
}
